const defaultState = () => ({
  details: {
    locale: undefined,
    name: undefined,
    vulnerability: undefined,
    severity: {
      id: 0,
      name: 'Não informado'
    },
    idCompany: undefined,
    visibility: undefined,
    description: undefined,
    idRuleDocumentation: undefined,
    cvss: undefined
  },
  conclusion_lessons: {
    conclusion: undefined,
    lesson: undefined
  },
  version_control: {
    conclusion: undefined,
  }
})
export default {
  namespaced: true,
  state: defaultState(),
  getters: {
    details: (state) => state.details,
    avaliables: (state) => state.avaliables,
    conclusion_lessons: (state) => state.conclusion_lessons,
    version_control: (state) => state.version_control,
    all: (state) => {
      return {
        ...state.details,
        ...state.avaliables,
        ...state.conclusion_lessons,
        ...state.version_control
      }
    }
  },
  mutations: {
    specific_tab: (state, { id, data }) => {
      state[id] = data
    },
    details: (state, { id, input }) => {
      state.details[id] = input
    },
    avaliables: (state, { id, input }) => {
      state.avaliables[id] = input
    },
    conclusion_lessons: (state, { id, input }) => {
      state.conclusion_lessons[id] = input
    },
    version_control: (state, { id, input }) => {
      state.version_control[id] = input
    },
    resetAll: state => {
      state.details = defaultState()['details']
      state.avaliables = defaultState()['avaliables']
      state.conclusion_lessons = defaultState()['conclusion_lessons']
      state.version_control = defaultState()['version_control']
    }
  }
}

